import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ComparisionCycle } from '../../../../../shared/enums/comparision-cycle.enum';
import { ReportName } from '../../../../../shared/enums/report-name.enum';
import { RaportZParametrami } from '../../../../../shared/models/raport';
import { EnumLabelPipe } from '../../pipes/event-type-label.pipe';
import { ApplicationTypeLabelPipe } from '../../pipes/application-type-label.pipe';
import { StatusLabelPipe } from '../../pipes/status-label.pipe';
import { EmptyFallbackPipe } from '../../../../../shared/pipes/empty-fallback.pipe';
import { SelectOption } from '../../../../../shared/models/select-option';

@Component({
  selector: 'app-report-parameters-dialog',
  imports: [
    Button,
    EnumLabelPipe,
    ApplicationTypeLabelPipe,
    StatusLabelPipe,
    EmptyFallbackPipe,
  ],
  templateUrl: './report-parameters-dialog.html',
  styleUrl: './report-parameters-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportParametersDialog {
  public report = input.required<RaportZParametrami>();
  public applicationTypeOptions = input.required<SelectOption<string>[]>();
  public reportName = ReportName;

  protected readonly dialogRef = inject(DynamicDialogRef);

  protected readonly isBaseReport = computed(
    () => this.report().nazwa.key === ReportName.BASIC_APPLICATION_REPORT,
  );

  protected readonly isComparisonReport = computed(
    () => this.report().nazwa.key === ReportName.COMPARATIVE_APPLICATION_REPORT,
  );

  protected readonly isHalfYearCycle = computed(
    () => this.report().cykl?.key === ComparisionCycle.HALF_YEAR,
  );

  protected readonly isQuarterCycle = computed(
    () => this.report().cykl?.key === ComparisionCycle.QUARTER,
  );

  protected readonly isMonthCycle = computed(
    () => this.report().cykl?.key === ComparisionCycle.MONTH,
  );

  protected readonly dataOdLabel = computed(() =>
    this.#formatDate(this.report().dataOd),
  );

  protected readonly dataDoLabel = computed(() =>
    this.#formatDate(this.report().dataDo),
  );

  protected readonly applicationTypeCodes = computed(() =>
    this.#valuesOrAll(this.report().rodzajWnioskuCode),
  );

  protected readonly statusCodes = computed(() =>
    this.#valuesOrAll(this.report().statusWniosku),
  );

  protected closeDialog(): void {
    this.dialogRef.close();
  }

  #valuesOrAll(values: string[] | null | undefined): string[] {
    return values?.length ? values : ['ALL'];
  }

  #formatDate(value: Date | string | null | undefined): string {
    if (!value) {
      return '-';
    }

    if (typeof value === 'string') {
      return value.trim() ? value.slice(0, 10) : '-';
    }

    if (Number.isNaN(value.getTime())) {
      return '-';
    }

    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}
